import { Handle, Position } from '@xyflow/react';
import { CButton } from '@coreui/react';
import { X } from 'lucide-react'; // icona per la X di eliminazione card
import { useCallback } from 'react';
import {t} from 'i18next';
import { useNavigate } from 'react-router-dom';

const CardLocationNode = ({ id, data }) => {

  const navigate = useNavigate();
  const handleDeleteClick = useCallback((e) => {
    e.stopPropagation();
    if (data.onDelete) data.onDelete(id);
  }, [data, id]);


  return (
    <div style={{
      padding: '10px',
      border: '3px solid #00BFA6',
      boxShadow: '0 0 30px #00BFA6',
      borderRadius: '15px',
      backgroundColor: 'var(--background-card-color)',
      textAlign: 'center',
    }}>
      {/* pulsante X per eliminare */}
      <button
        onClick={handleDeleteClick}
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          background: 'transparent',
          border: 'none',
           color: '#04fff2ff',
          cursor: 'pointer',
        }}
        title="Elimina nodo"
      >
        <X size={13} />
      </button>
      <p style={{color: 'white', borderBottom: '1px solid #00BFA6', fontWeight: '700'}}>{t('title.location')}</p>

      <CButton
        style={{
          borderRadius: '15px',
          backgroundColor: '#00BFA6'
        }}
        className='text-uppercase text-white'
        size="sm"
        onClick={() => navigate(`edit-cardLocation`)}
        // onClick={() => navigate(`${data.node.id}/edit-cardLocation`)}
      >
        {t('button.edit')}
      </CButton>

      {/* Handles per connettere i nodi */}
      <Handle type="target" position={Position.Left} />

    </div>
  );
};

export default CardLocationNode;
